import {
  getFailed,
  getStarted,
  getSucceeded,
  getEnded,
  statusEnum,
  FORGOT_PASSWORD_RESET_SET_DEFAULT,
  FORGOT_PASSWORD_RESET_SUBMIT,
  CLOSE_MODAL,
} from "../actions/constant";

const initialState = {
  isLoading: false,
  status: statusEnum.DEFAULT,
  actionResponse: null,
  submit: false,
};

// Forgot password reducer
function reducer(state = initialState, action) {
  switch (action.type) {
    case FORGOT_PASSWORD_RESET_SET_DEFAULT:
      return initialState;
    case getStarted(FORGOT_PASSWORD_RESET_SUBMIT):
      return { ...state, isLoading: true };
    case getSucceeded(FORGOT_PASSWORD_RESET_SUBMIT):
      return { ...state, status: statusEnum.SUCCESS, submit: true };
    case CLOSE_MODAL:
      return { ...state, submit: false };

    case getFailed(FORGOT_PASSWORD_RESET_SUBMIT):
      return {
        ...state,
        actionResponse: action.payload,
        status: statusEnum.ERROR,
      };
    case getEnded(FORGOT_PASSWORD_RESET_SUBMIT):
      return { ...state, isLoading: false };
    default:
      return state;
  }
}

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/forgotPasswordResetReducer.js